import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { Contact } from "@/models/Contact";
import { OPEN_CONTACT, CLOSE_CONTACT, LOAD_CONTACT_FROM_SERVER, FAILED_TO_LOAD_CONTACTS, SAVE_CONTACT_SCROLLTOP } from "./Types";
import { simpleAlert } from "@/pages/modules/alerts";
import { isExceptionViewModel, isCoreExceptionType } from "@/common/apiError";
import { showTemporaryChatDisabledAlert } from "@/components/temporaryChat";
import { getUserIdFromClientId } from "@/common/clientIdUtils";
import { UrlHelperExtensions } from "@/url_helpers";
import { CoreExceptionCodeEnum } from "@/apis/model/CoreExceptionCodeEnum";
export function loadedContactFromServer(contact) {
  return {
    type: LOAD_CONTACT_FROM_SERVER,
    contact: contact
  };
}
export function failedToLoadContacts(persistedContactInfos) {
  return {
    type: FAILED_TO_LOAD_CONTACTS,
    persistedContactInfos: persistedContactInfos
  };
}
export function openContact(contact) {
  return {
    type: OPEN_CONTACT,
    contact: contact
  };
}
export function closeContact(contact) {
  return {
    type: CLOSE_CONTACT,
    contact: contact
  };
}
export function saveContactScrollTop(contact, scrollTop) {
  return {
    type: SAVE_CONTACT_SCROLLTOP,
    contact: contact,
    scrollTop: scrollTop
  };
}
export function startChatWith(clientId) {
  var _this = this;

  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var myself, contacts, contact, result, otherUserId, qrcodeUrl, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);

            myself = getState().imSession.myself;
            contacts = getState().contact.contacts;
            if (!myself) return [3
            /*break*/
            , 3];
            contact = Object.values(contacts).filter(function (c) {
              return c.clientId === clientId;
            })[0];
            if (!!contact) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , Contact.getContactByClientId(clientId, myself)];

          case 1:
            result = _a.sent();

            if (isExceptionViewModel(result)) {
              if (isCoreExceptionType(result, CoreExceptionCodeEnum.ForbidTemporaryChatException) && result.ExceptionMessage) {
                otherUserId = getUserIdFromClientId(clientId);
                qrcodeUrl = UrlHelperExtensions.$ProfileUrl(otherUserId);
                showTemporaryChatDisabledAlert(qrcodeUrl, result.ExceptionMessage);
              } else if (result.ExceptionMessage) {
                simpleAlert(result.ExceptionMessage);
              }

              return [2
              /*return*/
              ];
            }

            contact = result;
            dispatch(loadedContactFromServer(contact));
            _a.label = 2;

          case 2:
            dispatch(openContact(contact));
            _a.label = 3;

          case 3:
            return [3
            /*break*/
            , 5];

          case 4:
            err_1 = _a.sent();
            console.error(err_1);
            return [3
            /*break*/
            , 5];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
}